import { general_File_str } from '@zenlayer/zen-design-icons';
import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Button from '../button';
import Elevation from '../elevation';
import { useConfig } from '../hooks/useConfig';
import Icon from '../icon';
import SvgIcon from '../svg-icon';
import bgIcon from './bg';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ListEmpty = props => {
  const {
    icon,
    title,
    whatIsUrl,
    desc,
    additional,
    action,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-listEmpty");
  const attrs = pickDomAttrs(restProps);
  const {
    locale: {
      Layout: LayoutLocale
    }
  } = useConfig();
  const whatIsDom = whatIsUrl && /*#__PURE__*/_jsx(Button, {
    icon: /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: general_File_str
    }),
    size: "s",
    type: "text",
    className: "whatIsButton",
    onClick: () => {
      window.open(whatIsUrl);
    },
    children: LayoutLocale.layout_basic_header_whatIs
  });
  return /*#__PURE__*/_jsxs(Elevation, {
    ...attrs.data,
    type: 2,
    className: classNames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/React.cloneElement(icon, {
      fontSize: 40
    }), /*#__PURE__*/_jsxs("span", {
      className: "title",
      children: [title, whatIsDom]
    }), /*#__PURE__*/_jsx("span", {
      className: "desc",
      children: desc
    }), additional && /*#__PURE__*/_jsx("div", {
      className: "additional",
      children: additional
    }), action && /*#__PURE__*/_jsx("div", {
      className: "action",
      children: action
    }), /*#__PURE__*/_jsx(Icon.CustomIcon, {
      component: bgIcon,
      className: "bgIcon"
    })]
  });
};
export default ListEmpty;